import { RecipeVariantProps, sva } from "styled-system/css";

export const statusIndicator = sva({
  slots: ["root", "label", "indicators"],
  base: {
    root: { flexDir: "column", alignItems: "center" },
    label: { color: "text.disabled" },
    indicators: { backgroundColor: "icon.disabled" },
  },
  variants: {
    display: {
      row: {
        root: { flexDir: "row", alignItems: "center", gap: "150" },
      },
      column: {
        root: { flexDir: "column", alignItems: "flex-end", gap: "25" },
      },
    },
    visual: {
      success: {
        label: { color: "text.success.mid" },
        indicators: { backgroundColor: "icon.success.mid" },
      },
      warning: {
        label: { color: "text.warning.mid" },
        indicators: { backgroundColor: "icon.warning.mid" },
      },
      error: {
        label: { color: "text.error.mid" },
        indicators: { backgroundColor: "icon.error.mid" },
      },
      "accent.blue": {
        label: { color: "text.accent.blue.mid" },
        indicators: { backgroundColor: "icon.accent.blue.mid" },
      },
      disabled: {
        indicators: { backgroundColor: "icon.disabled" },
      },
    },
  },
  defaultVariants: {
    display: "column",
    visual: "success",
  },
});

export type StatusIndicatorVariants = RecipeVariantProps<
  typeof statusIndicator
>;
